<template>
  <div class="table-action-wrapper">
    <a class="mb-2 btn-transition btn btn-outline-success" href="#" @click.prevent="handleAction('DesignReview')">Design review</a>
    <a class="mb-2 btn-transition btn btn-outline-success ml-2" href="#" @click.prevent="handleAction('DesignMapping')">Design mapping</a>
    <div class="main-table-action w-100">
      <component :is="view" :config="configAction" @changeFilters="handleChangeFilters"></component>
    </div>
  </div>
</template>
<script>
import * as components from './Action/'
export default {
  components: components,
  data() {
    return {
      view: false
    }
  },
  created() {
    //
  },
  computed: {
    configAction() {
      return this.config
    }
  },
  methods: {
    handleAction(action) {
      if (this.view != false && !confirm('You are performing another action. Are you sure you want to change?')) {
        return
      }
      if (action in this.$options.components) {
        this.view = action
      } else {
        this.view = false
      }
    },
    handleChangeFilters(query, args) {
      this.$emit('change-filters', query, args)
    }
  },
  props: {
    config: Object
  }
}
</script>
